module.exports = __webpack_public_path__ + "img/right4.669212e9.png";